module.exports = __webpack_public_path__ + "static/media/lynda_mock.78d0353f.jpg";